import React from "react"
import ReactDOM from "react-dom"
import {Helmet} from "react-helmet";
import {Provider} from "react-redux"
import {BrowserRouter} from "react-router-dom"
import {ThemeProvider} from "@material-ui/core/styles"

// Translations
import "./translations/i18n"

// Styles
import "./index.css"

// Root component
import App from "./App"

// Components
import ErrorBoundary from "./components/ErrorBoundary"

// Service Worker
import * as serviceWorker from "./serviceWorker"

// Redux store
import getReduxStore from "./store"

// Theme
import theme from "./theme"

// UI skin
import {UiSkinProvider} from "./modules/ui-skin/context/UiSkinContext"

// Helpers
declare var Title: any;
declare var FaviconUrl: any;
declare var ManifestUrl: any;

// UiSkinProvider resolves the skin synchronously in a lazy state initialiser,
// so it needs no router context and can sit above BrowserRouter. The classic
// ThemeProvider stays exactly where it was; the Modern theme nests below it,
// inside LayoutSwitch.
// Outermost on purpose: it depends on nothing below it — inline styles and the
// i18n singleton only — so it can also catch a provider or the theme throwing,
// which is exactly the class of failure that leaves a blank page.
ReactDOM.render(
    <ErrorBoundary>
    <Provider store={getReduxStore()}>
        <UiSkinProvider>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                  <Helmet>
                    <title>{Title()}</title>
                    <link rel="icon" href={FaviconUrl()}/>
                    <link rel="manifest" href={ManifestUrl()}/>
                  </Helmet>
                    <App/>
                </BrowserRouter>
            </ThemeProvider>
        </UiSkinProvider>
    </Provider>
    </ErrorBoundary>,
    document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
